/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line

  // Força filtro de disponibilidade (em estoque) quando há filtro de tamanho na URL
  // Adicionado por Ítalo em 23/06/2025
  function forcarFiltroDisponibilidade() {
    var params = new URLSearchParams(window.location.search);
    var temFiltroTamanho = params.has('filter.v.option.tamanho');
    var temDisponibilidade = params.has('filter.v.availability');

    if (temFiltroTamanho && !temDisponibilidade) {
      params.set('filter.v.availability', '1');
      var novaUrl = window.location.pathname + '?' + params.toString();
      // Força reload completo para o Shopify processar o filtro corretamente
      window.location.replace(novaUrl);
    }
  }

  // Roda na carga inicial da página
  forcarFiltroDisponibilidade();

  // Intercepta o pushState do AJAX do tema (Skylight usa history.pushState ao filtrar)
  var _pushState = history.pushState.bind(history);
  history.pushState = function(state, title, url) {
    _pushState(state, title, url);
    // Aguarda a URL ser atualizada antes de checar
    setTimeout(forcarFiltroDisponibilidade, 50);
  };

  // Também escuta navegação pelo botão voltar/avançar do browser
  window.addEventListener('popstate', forcarFiltroDisponibilidade);

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();